
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n495Child = []
  var n496Child = []
  var n497Child = []
  n497Child = n497Child.concat(text(t('.instance_id')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n497 = h('label', props, n497Child)
  n496Child.push(n497)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n496 = h('div', props, n496Child)
  n495Child.push(n496)
  var n498Child = []
  var n499Child = []
  var n500Child = []
  var n501Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "instanceId"},{name:'value', val: shadow.instanceId},{name:'type', val: "text"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n501 = h('input', props, n501Child)
  n500Child.push(n501)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n500 = h('div', props, n500Child)
  n499Child.push(n500)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n499 = h('div', props, n499Child)
  n498Child.push(n499)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n498 = h('div', props, n498Child)
  n495Child.push(n498)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n495 = h('div', props, n495Child)
  n0Child.push(n495)
  var n502Child = []
  var n503Child = []
  var n504Child = []
  n504Child = n504Child.concat(text(t('.caller_name')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n504 = h('label', props, n504Child)
  n503Child.push(n504)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n503 = h('div', props, n503Child)
  n502Child.push(n503)
  var n505Child = []
  var n506Child = []
  var n507Child = []
  var n508Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "callerName"},{name:'value', val: shadow.callerName},{name:'type', val: "text"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n508 = h('input', props, n508Child)
  n507Child.push(n508)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n507 = h('div', props, n507Child)
  n506Child.push(n507)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n506 = h('div', props, n506Child)
  n505Child.push(n506)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n505 = h('div', props, n505Child)
  n502Child.push(n505)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n502 = h('div', props, n502Child)
  n0Child.push(n502)
  var n509Child = []
  var n510Child = []
  var n511Child = []
  n511Child = n511Child.concat(text(t('.caller_number')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n511 = h('label', props, n511Child)
  n510Child.push(n511)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n510 = h('div', props, n510Child)
  n509Child.push(n510)
  var n512Child = []
  var n513Child = []
  var n514Child = []
  var n515Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "callerNumber"},{name:'value', val: shadow.callerNumber},{name:'type', val: "text"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n515 = h('input', props, n515Child)
  n514Child.push(n515)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n514 = h('div', props, n514Child)
  n513Child.push(n514)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n513 = h('div', props, n513Child)
  n512Child.push(n513)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n512 = h('div', props, n512Child)
  n509Child.push(n512)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n509 = h('div', props, n509Child)
  n0Child.push(n509)
  var n516Child = []
  var n517Child = []
  var n518Child = []
  n518Child = n518Child.concat(text(t('.ring')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n518 = h('label', props, n518Child)
  n517Child.push(n518)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n517 = h('div', props, n517Child)
  n516Child.push(n517)
  var n519Child = []
  var n520Child = []
  var n521Child = []
  var n522Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "ring[assetId]"},{name:'value', val: shadow.ring.assetId},{name:'type', val: "text"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n522 = h('input', props, n522Child)
  n521Child.push(n522)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n521 = h('div', props, n521Child)
  n520Child.push(n521)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n520 = h('div', props, n520Child)
  n519Child.push(n520)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n519 = h('div', props, n519Child)
  n516Child.push(n519)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n516 = h('div', props, n516Child)
  n0Child.push(n516)
  var n523Child = []
  var n524Child = []
  var n525Child = []
  n525Child = n525Child.concat(text(t('.call_audio')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n525 = h('label', props, n525Child)
  n524Child.push(n525)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n524 = h('div', props, n524Child)
  n523Child.push(n524)
  var n526Child = []
  var n527Child = []
  var n528Child = []
  var n529Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "call[assetId]"},{name:'value', val: shadow.call.assetId},{name:'type', val: "text"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n529 = h('input', props, n529Child)
  n528Child.push(n529)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n528 = h('div', props, n528Child)
  n527Child.push(n528)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n527 = h('div', props, n527Child)
  n526Child.push(n527)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n526 = h('div', props, n526Child)
  n523Child.push(n526)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n523 = h('div', props, n523Child)
  n0Child.push(n523)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  